/* eslint-disable @typescript-eslint/camelcase */
import {
  makeStyles,
  TextField,
  InputAdornment,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import Permission from 'components/ValidPermission';
import InputIcon from '@material-ui/icons/Input';
import { FormikErrors } from 'formik';
import i18n from 'i18n';
import { get } from 'lodash';
import { ClientFields } from 'modules/clients/interfaces';
import { modalOpen } from 'modules/modal/actions';
import { useHistory } from 'react-router-dom';
import { ModalFields } from 'modules/modal/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import EnvironmentList from './environmentList';
import styles from './styles';

const useStyles = makeStyles(styles);

export interface EnvironmentFieldsProps {
  environment_name?: string;
  environment_uuid?: string;
}

interface SelectEnvironmentProps {
  errors?: FormikErrors<any>;
  initialEnvironment?: ClientFields['environment'];
  isEdit?: boolean;
  stateKey: string;
  modalOpen: (props: ModalFields) => void;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void;
}
const SelectEnvironment = ({
  errors,
  initialEnvironment,
  isEdit,
  stateKey,
  modalOpen,
  setFieldValue,
}: SelectEnvironmentProps) => {
  const history = useHistory();
  const [environmentFields, setEnvironmentFields] = React.useState<
    EnvironmentFieldsProps
  >({
    environment_name: initialEnvironment?.name,
    environment_uuid: initialEnvironment?.environment_uuid,
  });

  const classes = useStyles();

  return (
    <TextField
      className={classes.selectEnvironmentField}
      fullWidth
      id="btn-select-environment"
      label={i18n.t('ENVIRONMENT_KEY')}
      placeholder={i18n.t('CHOOSE_ENVIRONMENT_KEY')}
      value={environmentFields?.environment_name || ''}
      variant="outlined"
      InputProps={{
        readOnly: true,
        startAdornment: environmentFields?.environment_uuid && (
          <Permission value="list_environment_instances">
            <InputAdornment position="start">
              <Tooltip
                placement="top"
                arrow
                title={i18n.t('ACCESS_ENVIRONMENT_KEY')}
              >
                <IconButton
                  className={classes.accessButton}
                  onClick={e => {
                    e.stopPropagation();
                    history.push(
                      `/environments/${environmentFields?.environment_uuid}/instances`
                    );
                  }}
                >
                  <InputIcon />
                </IconButton>
              </Tooltip>
            </InputAdornment>
          </Permission>
        ),
      }}
      InputLabelProps={{ shrink: true }}
      error={!!get(errors, stateKey)}
      helperText={get(errors, stateKey)}
      onClick={() =>
        modalOpen({
          title: i18n.t('CHOOSE_ENVIRONMENT_KEY'),
          content: (
            <EnvironmentList
              environmentFields={environmentFields}
              stateKey={stateKey}
              setEnvironmentFields={setEnvironmentFields}
              setFieldValue={setFieldValue}
              isEdit={isEdit}
            />
          ),
          maxWidth: 'md',
          fullWidth: true,
          genericFooter: {},
        })
      }
    />
  );
};

export default connect(null, { modalOpen })(SelectEnvironment);
